import styles from "./LogoSlider.module.css";

export default function LogoSlider({ items }) {
  const doubled = [...items, ...items];
  return (
    <div className={styles.wrapper}>
      <div className={styles.track}>
        {doubled.map((item, i) => (
          <div className={styles.item} key={i} title={item.name}>
            <img src={item.logo} alt={item.name} className={styles.logo} />
          </div>
        ))}
      </div>
    </div>
  );
}
